<template>
  <Section>
    <div class="content d-flex align-center">
      <div class="flex-grow-1 black--text font-weight-bold">
        Referrals: {{ pro.referrals_enabled ? 'Enabled' : 'Disabled' }}<br>
        Leads in last 30 days: {{ pro.leads_count }}
      </div>
      <div>
        <v-switch
          color="primary"
          hide-details
          inset
          label="On"
          :input-value="pro.referrals_enabled"
          class="mt-0 enable_switch"
          @change="switchChange"
        ></v-switch>
      </div>
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import { mapActions } from 'vuex'

  export default {
    name: 'EnableSection',

    props: ['pro'],

    components: { Section },

    methods: {
      ...mapActions('auth', ['updateMe']),

      switchChange(event) {
        this.updateMe({ referrals_enabled: event })
      }
    },
  }
</script>

<style>
  .pldc .enable_switch label {
    font-size: 14px;
  }
</style>